import { createContext, useCallback, useContext } from "react";

const DEFAULT_IS_READONLY = false;
const NO_PROVIDER_ERROR_MESSAGE: string =
    "useReadonlyContext must be used within a ReadonlyContextProvider";

interface UseReadonlyContext {
    isReadonly: boolean;
    skipIfIsReadonly: <T extends Function>(callback: T) => T;
}

export const ReadonlyContext = createContext<boolean>(DEFAULT_IS_READONLY);

export const useReadonlyContext = (): UseReadonlyContext => {
    const isReadonly = useContext(ReadonlyContext);

    const skipIfIsReadonly = useCallback(
        <T extends Function>(callback: T): T => {
            if (isReadonly) {
                return (() => {}) as unknown as T;
            }

            return callback;
        },
        [isReadonly]
    );

    if (isReadonly == null) {
        throw new Error(NO_PROVIDER_ERROR_MESSAGE);
    }

    return {
        isReadonly: isReadonly,
        skipIfIsReadonly: skipIfIsReadonly,
    };
};
